export const PAGE_OPTION_NAME = 'multi_page_tutorial_settings';
export const OPTION_KEY_SHOW_NEXT_TOP = 'show_next_top';
export const OPTION_KEY_TIME_REQUIRED = 'time_required';
export const LINK_TITLE = 'Next Step';
